import React from "react"
import { Button, Heading, Paragraph } from "@gorilla-technologies/customer-ui"
import { Layout } from "../components"

const NotFoundPage = () => (
  <Layout title="Not found (404)">
    <div className="mt-20 flex flex-col items-center gap-12">
      <Heading level={1}>Page not found (404)</Heading>
      <Paragraph level={1}>
        Head home to see if you can find your way.
      </Paragraph>
      <Button
        title="Take me home!"
        onClick={() => {
          window.open("/", "_self")
        }}
      />
    </div>
  </Layout>
)

export default NotFoundPage
